<template>
  <div class="records-container">
    <el-card shadow="hover" class="records-card">
      <template #header>
        <div class="card-header">
          <div class="header-line"></div>
          <h3 class="header-title">提现记录</h3>
        </div>
      </template>

      <div class="filter-container">
        <el-form :inline="true" :model="filterForm">
          <el-form-item label="提现方式">
            <el-select v-model="filterForm.type" placeholder="全部方式" clearable class="filter-select">
              <el-option label="支付宝" value="1" />
              <el-option label="银行卡" value="2" />
            </el-select>
          </el-form-item>

          <el-form-item label="状态">
            <el-select v-model="filterForm.status" placeholder="全部状态" clearable class="filter-select">
              <el-option label="待审核" value="0" />
              <el-option label="审核通过" value="1" />
              <el-option label="已打款" value="2" />
              <el-option label="打款失败" value="3" />
              <el-option label="已驳回" value="4" />
              <el-option label="已取消" value="5" />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="fetchRecords" class="search-btn">
              搜索
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table :data="records" border style="width: 100%" class="records-table">
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="amount" label="金额" width="120" align="center">
          <template #default="{ row }">¥{{ row.amount }}</template>
        </el-table-column>
           <el-table-column prop="fee" label="手续费" width="120" align="center">
          <template #default="{ row }">¥{{ row.fee }}</template>
        </el-table-column>
           <el-table-column prop="actual_amount" label="实际到账金额" width="120" align="center">
          <template #default="{ row }">¥{{ row.actual_amount }}</template>
        </el-table-column>
        <el-table-column prop="payment_method" label="提现方式" width="100" align="center">
          <template #default="{ row }">
            {{ row.payment_method == 'alipay' ? '支付宝' : '银行卡' }}
          </template>
        </el-table-column>
        <el-table-column prop="account_name" label="提现姓名" width="120"  align="center"/>
        <el-table-column prop="account_number" label="提现账号" width="180"  align="center"/>
        <el-table-column prop="status" label="状态" width="120" align="center">
          <template #default="{ row }">
            <el-tag :type="row.status == 2 ? 'success' :
              row.status == 3 || row.status == 4 ? 'danger' : 'warning'" effect="dark">
              {{ getStatusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="申请时间" width="180" />
        <el-table-column prop="update_time" label="完成时间" width="180" />
        <el-table-column prop="remark" label="备注" />
      </el-table>

      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 50]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'WithdrawRecords',
  data() {
    return {
      records: [],
      filterForm: {
        type: '',
        status: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.fetchRecords()
  },
  methods: {
    fetchRecords() {
      const params = {
        ...this.filterForm,
        page: this.pagination.currentPage,
        size: this.pagination.pageSize
      }

      this.$axios.get('api/Bloger/getWithdrawalRecords', { params })
        .then(res => {
          this.records = res.data.list
          this.pagination.total = res.data.total
        })
    },
    getStatusText(status) {
      const map = {
        0: '待审核',
        1: '审核通过',
        2: '已打款',
        3: '打款失败',
        4: '已驳回',
        5: '已取消'
      }
      return map[status] || '未知状态'
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchRecords()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchRecords()
    }
  }
}
</script>

<style scoped>
.records-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.records-card {
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.header-line {
  width: 4px;
  height: 20px;
  background: linear-gradient(to bottom, #409EFF, #67C23A);
  border-radius: 2px;
  margin-right: 10px;
}

.header-title {
  margin: 0;
  font-size: 18px;
  color: #303133;
  font-weight: 600;
}

.filter-container {
  margin-bottom: 20px;
}

.filter-select {
  width: 120px;
}

.search-btn {
  width: 100px;
}

.records-table {
  margin-top: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}
</style>
